import { cn } from '@tripleten/cn';

export const cnLoginVerifyEmail = cn('login-verify-email');
